module.exports = __webpack_public_path__ + "public/images/Outschool_Glyph.08596fc84fd696f6a706509963070373.svg";